"use client";

import React, { useState } from "react";
import { Icons } from "@/shared/Icons/Icons";
import styles from "./styles.module.css";

interface CommonVDropperProps {
	title: string;
	text: string;
}

export const CommonVDropper = ({ title, text }: CommonVDropperProps) => {
	const [isOpen, setIsOpen] = useState(false);

	const toggleDropper = () => {
		setIsOpen(!isOpen);
	};

	return (
		<div className={`${styles.dropper} ${isOpen ? styles.active : ""}`}>
			<div className={styles.dropperHeader} onClick={toggleDropper}>
				<h3 className={styles.dropperTitle}>{title}</h3>
				<div className={styles.dropperIcon}>
					{isOpen ? (
						<div className={styles.rotatedUp}>
							<Icons.ArrowRight />
						</div>
					) : (
						<div className={styles.rotatedDown}>
							{" "}
							<Icons.ArrowRight />
						</div>
					)}
				</div>
			</div>
			{isOpen && (
				<div className={styles.dropperContent}>
					<div dangerouslySetInnerHTML={{ __html: text }} />
				</div>
			)}
		</div>
	);
};

export default CommonVDropper;
